import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import Header from "../components/header/Header";
import ProgressBar from "../components/progressBar/ProgressBar";
import { FiArrowRight } from "react-icons/fi";
import FlowField from "../components/forms/FlowField";
import "./styles/flow-form.css";
import { addToCart } from "../redux/actions/CartActions";
import { useDispatch, useSelector } from "react-redux";
import Swal from "sweetalert2";
import { updateBusinessRequest } from "../redux/actions/RequestActions";
import Loader from "../components/loader/Loader";

// Validation schema
const validationSchema = Yup.object({
  businessAddress: Yup.string().required(
    "Le siège social de l'entreprise est requis",
  ),
});

function BusinessAddress() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const currentStep = "Entreprise";
  const steps = [
    "Propriétaire",
    "Entreprise",
    "Services",
    "Paiement",
    "Finalisation",
  ];
  const cart = useSelector((state) => state.cart);
  const { user } = useSelector((state) => state.authUser);
  const [submitting, setSubmitting] = useState(false);
  const { businessCreationRequest } = useSelector((state) => state.request);

  const handleSubmit = async (values) => {
    setSubmitting(true);
    await dispatch(
      addToCart({
        businessAddress: values.businessAddress,
      }),
    );
    if (cart.from === "creation") {
      await dispatch(
        updateBusinessRequest(
          user.token,
          businessCreationRequest.reference,
          {
            address: values.businessAddress,
          },
          handleCallback,
        ),
      );
    } else {
      navigate("/turnover");
    }
  };

  const handleCallback = ({ success, message }) => {
    const Toast = Swal.mixin({
      toast: true,
      position: "top-end",
      showConfirmButton: false,
      timer: 4000,
    });
    if (success) {
      navigate("/cart");
    } else {
      Toast.fire({
        icon: "error",
        title: "Échec",
        text: message,
      });
    }
    setSubmitting(false);
  };

  return (
    <div className="flow-form-page">
      <Header />
      <Loader isLoading={submitting} />
      <ProgressBar steps={steps} currentStep={currentStep} />

      <header className="flow-form-header">
        <h1 className="flow-form-title">
          Quelle est l'adresse du <span>siège social</span> ?
        </h1>
        <p className="flow-form-lead">
          L'adresse officielle de votre entreprise.
        </p>
      </header>

      <Formik
        initialValues={{ businessAddress: cart.businessAddress || "" }}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        <Form className="flow-form" noValidate>
          <FlowField
            name="businessAddress"
            label="Adresse complète"
            placeholder="Ex. : Rue 1.234, Bonapriso, Douala"
            autoComplete="street-address"
          />

          <div className="flow-actions">
            <button type="submit" className="flow-submit" disabled={submitting}>
              Continuer <FiArrowRight aria-hidden="true" />
            </button>
          </div>
        </Form>
      </Formik>
    </div>
  );
}

export default BusinessAddress;
